/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./panel-page/panel-page.component.ngfactory";
import * as i3 from "../Common/Services/manage-child-headers.service";
import * as i4 from "./panel-page/panel-page.component";
import * as i5 from "@angular/router";
import * as i6 from "../Common/Services/utility";
import * as i7 from "../Common/Services/app.global";
import * as i8 from "../Common/Services/shared.service";
import * as i9 from "@angular/material";
import * as i10 from "../Common/appMessage";
import * as i11 from "@angular/common";
import * as i12 from "./app.component";
import * as i13 from "@angular/platform-browser";
var styles_AppComponent = [i0.styles];
var RenderType_AppComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppComponent, data: {} });
export { RenderType_AppComponent as RenderType_AppComponent };
export function View_AppComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵted(-1, null, [" "])), (_l()(), i1.ɵeld(1, 0, null, null, 2, "app-panel-page", [], null, null, null, i2.View_PanelPageComponent_0, i2.RenderType_PanelPageComponent)), i1.ɵprd(512, null, i3.ManageChildHeadersService, i3.ManageChildHeadersService, []), i1.ɵdid(3, 245760, null, 0, i4.PanelPageComponent, [i5.Router, i5.ActivatedRoute, i6.Utility, i7.AppGlobals, i8.SharedService, i3.ManageChildHeadersService, i9.MdDialog, i10.AppMessage, i11.Location], null, null), (_l()(), i1.ɵted(-1, null, ["\n"]))], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
export function View_AppComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-root", [], null, null, null, View_AppComponent_0, RenderType_AppComponent)), i1.ɵdid(1, 114688, null, 0, i12.AppComponent, [i13.Title], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AppComponentNgFactory = i1.ɵccf("app-root", i12.AppComponent, View_AppComponent_Host_0, {}, {}, []);
export { AppComponentNgFactory as AppComponentNgFactory };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/app.component.ngfactory.js.pre-build-optimizer.js